import { getFolderResourceItems, resourceFolderFileUrl } from './folderResources';

const SEGMENT = 'community';

/** Files in public/resources/community/ - add one row per file. */
export const COMMUNITY_RESOURCE_FILES = [
  {
    id: 'community-doc-1774443856590',
    title: 'Community resource document',
    description: 'PDF available in the community resources library.',
    filename: '1774443856590.pdf',
    icon: '📄',
  },
  {
    id: 'prosperity-report-stem-2020',
    title:
      "Prosperity Report: Illustrated Workfinding and Immigrant Women's Prosperity in STEM",
    description: 'June 2020 illustrated report on workfinding and prosperity in STEM.',
    filename:
      'Prosperity+Report+I+-+Illustrated+Workfinding+and+Immigrant+Women_s+Prosperity+in+STEM+-+June+2020.pdf',
    icon: '📄',
  },
];

export function communityResourceFileUrl(filename) {
  return resourceFolderFileUrl(SEGMENT, filename);
}

export function getCommunityResourceItems() {
  return getFolderResourceItems(SEGMENT, COMMUNITY_RESOURCE_FILES);
}
